module.exports = __webpack_public_path__ + "static/media/innov_1.c7cff3bc.jpg";